import React, { useState, useEffect, useCallback } from 'react';

import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

//import { DateTimePicker } from "@material-ui/pickers";
//import { DateTimePicker } from '@mui/lab';
//import { StaticDateTimePicker } from '@mui/x-date-pickers/StaticDateTimePicker';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';

import { distancePeriodsMain, getperiod } from '../../utils/datePeriodCalculator';
import { TextField } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: useTheme().spacing(1),
        width: 200,
    },
}));


const GetPeriod = ({ fromDate, onFromDateChange, toDate, onToDateChange, periodType = 'today' }) => {
    const classes = useStyles();
    const [period, setPeriod] = useState(periodType);

    const onPeriodChange = (e) => {
        //console.log("On periodChange from", period, "to", e.target.value);
        setPeriod(e.target.value);
        if (e.target.value !== "custom") {
            const { fromDate, toDate } = getperiod(e.target.value);
            onFromDateChange(fromDate, e.target.value);
            onToDateChange(toDate, e.target.value);
        }
    }
    //console.log("GP Period", periodType, period);
    const dateUpdate = useCallback(
        () => {
            //console.log("Get period issue", periodType, period);
            const { fromDate, toDate } = getperiod(periodType);
            onFromDateChange(fromDate, periodType);
            onToDateChange(toDate, periodType);
        },
        [periodType, onFromDateChange, onToDateChange],
    );

    useEffect(() => {
        //console.log("On Mount", periodType);
        if (periodType !== "custom" && periodType !== period) {
            //console.log("PriodType", periodType);
            dateUpdate();
        }
        setPeriod(periodType);
    }, [periodType, dateUpdate, period]);



    const fromDateHandler = (e) => {
        //console.log("From date handler");
        onFromDateChange(e);
        setPeriod("custom");
    }

    const toDateHandler = (e) => {
        //console.log("To date handler");
        onToDateChange(e);
        setPeriod("custom");
    }

    return (
        <Grid container item sm={12}>
            <Grid item sm={12}>
                <FormControl className={classes.formControl}>
                    <InputLabel id="periodLabel">Peiod Type</InputLabel>
                    <Select
                        variant="standard"
                        labelId="periodLabel"
                        id="peiodTypeSelect"
                        value={period}
                        onChange={onPeriodChange}
                    >
                        {
                            distancePeriodsMain.map(ev => <MenuItem key={ev.value} value={ev.value}>{ev.name}</MenuItem>)
                        }
                        <MenuItem key={"custom"} value={"custom"}>{"Custom"}</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item sm={12}>
                <FormControl className={classes.formControl}>
                    <DesktopDateTimePicker

                        autoOk
                        ampm={true}
                        disableFuture
                        value={fromDate}
                        onChange={fromDateHandler}
                        format="Do MMM YY h:mm a"
                        renderInput={(props) => <TextField variant="standard" label="Period From" {...props} />}
                    />
                </FormControl>
            </Grid>
            <Grid item sm={12}>
                <FormControl className={classes.formControl}>

                    <DesktopDateTimePicker
                        autoOk
                        ampm={true}
                        disableFuture
                        value={toDate}
                        onChange={toDateHandler}
                        format="Do MMM YY h:mm a"
                        renderInput={(props) => <TextField variant="standard" label="Period To" {...props} />}
                    />
                </FormControl>
            </Grid>
        </Grid>
    );
}

export default React.memo(GetPeriod);